import { semanticColors, spacing } from '@moderneinc/design-system-tokens';
import { Stack } from '@mui/material';
import type { FunctionComponent } from 'react';
import { KeyHint } from '../keyboard-shortcuts/keyboard-shortcuts.component';
import { SearchDocs } from './ai-search-docs.component';

export const SearchModalFooter: FunctionComponent = () => {
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2.5,
        py: 1.5,
        borderTop: `1px solid ${semanticColors.color.border.primary}`
      }}
    >
      <Stack
        direction="row"
        sx={{
          gap: `${spacing.spacing_2}px`,
          alignItems: 'center'
        }}
      >
        <KeyHint keys={['↑', '↓']} label="Navigate" />
        <KeyHint keys={['Enter']} label="Select" />
        <KeyHint keys={['Esc']} label="Close" />
      </Stack>
      <SearchDocs />
    </Stack>
  );
};
